import React from "react";
import "./TeamPage.css";
import TeamCard from "./TeamCard";
import team_members from "../../data/team_members";

export default function TeamPage() {
    const faculty_head = team_members["faculty_head"];
    const staff_members = team_members["staff_members"];
    const student_members = team_members["student_members"];

    return (
        <div className="team">
            <div className="team-heading">
                <h1 className="team-heading1">
                    Meet the <span className="team-heading-highlight">Team</span>
                </h1>
                <hr className="team-heading-hr" />
                <h3 className="team-heading2">
                    Introducing the members that make it happen!
                </h3>
            </div>

            <div className="faculty-head">
                <h3 className="faculty-head-title">
                    <span className="team-heading-highlight">Faculty</span> Head
                </h3>
                <div className="faculty-head-list">
                    {faculty_head.map((faculty, index) => (
                        <TeamCard key={index} details={faculty} member_type="faculty" />
                    ))}
                </div>
            </div>

            <div className="staff-members">
                <h3 className="staff-members-title">
                    <span className="team-heading-highlight">Staff</span> Members
                </h3>
                <div className="staff-members-list">
                    {[staff_members.slice(0, 2), staff_members.slice(2, 5), staff_members.slice(5, 7)].map((row, rowIndex) => (
                        <div className="staff-row" key={rowIndex}>
                            {row.map((staff, index) => (
                                <TeamCard key={index} details={staff} member_type="staff" />
                            ))}
                        </div>
                    ))}
                </div>
            </div>


            <hr className="team-split-hr"/>

            <div className="student-members">
                <h3 className="student-members-title">
                    <span className="team-heading-highlight">Student</span> Members
                </h3>
                {student_members.map((vertical, vIndex) => (
                    <div key={vIndex} className="student-vertical">
                        <h4 className="student-vertical-title">{vertical.vertical}</h4>
                        <div className="student-vertical-list">
                            {vertical.members.map((student, sIndex) => (
                                <TeamCard key={sIndex} details={student} member_type={`student`} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
